/* Utilisation des machines en production */
const USE_PUMP_OPTION = "USE_PUMP";
const USE_CASA_OPTION = "USE_CASA";

const USE_INPUT_ABSORBANCE_OPTION = "INPUT_ABSORBANCE";
const USE_PREDILUTION_OPTION = "USE_PREDILUTION";

const TYPE_CASA_OPTION = "TYPE_CASA";

/* Seuils options production */
const THRESHOLD_CONCENTRATION_OPTION = "THRESHOLD_CONCENTRATION";
const THRESHOLD_MOTILITY_OPTION = "THRESHOLD_MOTILITY";
const THRESHOLD_PRC_LIVING_OPTION = "THRESHOLD_PRC_LIVING";
const THRESHOLD_VOLUME_DILUTED = "THRESHOLD_VOLUME_DILUTED";

const THRESHOLD_CASA_NORMAUX_OPTION = "THRESHOLD_CASA_NORMAUX";
const THRESHOLD_CASA_UTILE_OPTION = "THRESHOLD_CASA_UTILE";
const THRESHOLD_CASA_MOTILITY_OPTION = "THRESHOLD_CASA_MOTILITY";

const PRC_PREDILUTION_OPTION = "PRC_PREDILUTION";
const DIVIDER_CONCENTRATION_OPTION = "DEVIDER_CONCENTRATION";
const LABELS_NUMBERS_OPTION = "LABELS_NUMBER";
const LABELS_NUMBERS_HETERO_OPTION = "LABELS_NUMBER_HETERO";

const FAVORITE_BUILDING_OPTION = "FAVORITE_BUILDING";

const VOLUME_AMORCE_OPTION = "VOLUME_AMORCE";
// Bornes de saisie du volume d'amorce par défaut (ml). Mantis 0027543 : le plafond à 100 empêchait
// de saisir une amorce plus grande (120 repassait à 100) ; 0 reste autorisé (amorce désactivée).
const VOLUME_AMORCE_MIN = 0;
const VOLUME_AMORCE_MAX = 999;
const CONCENTRATION_FINALE_OPTION = "CONCENTRATION_FINALE";
const VOLUME_STANDARD_OPTION = "VOLUME_STANDARD";

const BORNE_MIN_HETERO_STANDARD = "BORNE_MIN_HETERO_STANDARD";
const BORNE_MAX_HETERO_STANDARD = "BORNE_MAX_HETERO_STANDARD";
const BORNE_MIN_HETERO_ARMADA   = "BORNE_MIN_HETERO_ARMADA";
const BORNE_MAX_HETERO_ARMADA   = "BORNE_MAX_HETERO_ARMADA";

const SPZ_TOTAL_CLEAN_OPTION = "SPZ_TOTAL_CLEAN";
const SPZ_TOTAL_DILUTED_OPTION = "SPZ_TOTAL_DILUTED";

const CASA_BLADE_FRESH = "CASA_BLADE_FRESH";
const CASA_BLADE_STORED = "CASA_BLADE_STORED";

/* Bornes sanitaires : indicatives (non bloquantes) et de saisie (bloquantes, contiennent
   toujours les indicatives) — éditées par centre dans Gestion des options > Sanitaire. */
const SAN_POIDS_INDICATIF_MIN = "SAN_POIDS_INDICATIF_MIN";
const SAN_POIDS_INDICATIF_MAX = "SAN_POIDS_INDICATIF_MAX";
const SAN_POIDS_SAISIE_MIN = "SAN_POIDS_SAISIE_MIN";
const SAN_POIDS_SAISIE_MAX = "SAN_POIDS_SAISIE_MAX";
const SAN_TEMPERATURE_INDICATIF_MIN = "SAN_TEMPERATURE_INDICATIF_MIN";
const SAN_TEMPERATURE_INDICATIF_MAX = "SAN_TEMPERATURE_INDICATIF_MAX";
const SAN_TEMPERATURE_SAISIE_MIN = "SAN_TEMPERATURE_SAISIE_MIN";
const SAN_TEMPERATURE_SAISIE_MAX = "SAN_TEMPERATURE_SAISIE_MAX";

export {
    USE_CASA_OPTION,
    USE_PUMP_OPTION,
    TYPE_CASA_OPTION,
    USE_INPUT_ABSORBANCE_OPTION,
    USE_PREDILUTION_OPTION,
    THRESHOLD_CONCENTRATION_OPTION,
    THRESHOLD_MOTILITY_OPTION,
    THRESHOLD_PRC_LIVING_OPTION,
    THRESHOLD_VOLUME_DILUTED,

    THRESHOLD_CASA_NORMAUX_OPTION,
    THRESHOLD_CASA_UTILE_OPTION,
    THRESHOLD_CASA_MOTILITY_OPTION,

    FAVORITE_BUILDING_OPTION,

    PRC_PREDILUTION_OPTION,
    DIVIDER_CONCENTRATION_OPTION,
    LABELS_NUMBERS_OPTION,
    LABELS_NUMBERS_HETERO_OPTION,
    VOLUME_AMORCE_OPTION,
    VOLUME_AMORCE_MIN,
    VOLUME_AMORCE_MAX,
    CONCENTRATION_FINALE_OPTION,
    VOLUME_STANDARD_OPTION,

    BORNE_MIN_HETERO_STANDARD,
    BORNE_MAX_HETERO_STANDARD,
    BORNE_MIN_HETERO_ARMADA,
    BORNE_MAX_HETERO_ARMADA,

    CASA_BLADE_FRESH,
    CASA_BLADE_STORED,

    SPZ_TOTAL_CLEAN_OPTION,
    SPZ_TOTAL_DILUTED_OPTION,

    SAN_POIDS_INDICATIF_MIN,
    SAN_POIDS_INDICATIF_MAX,
    SAN_POIDS_SAISIE_MIN,
    SAN_POIDS_SAISIE_MAX,
    SAN_TEMPERATURE_INDICATIF_MIN,
    SAN_TEMPERATURE_INDICATIF_MAX,
    SAN_TEMPERATURE_SAISIE_MIN,
    SAN_TEMPERATURE_SAISIE_MAX
}
